import React from 'react'
import ReactEcharts from 'echarts-for-react';
import * as echarts from "echarts";

export default function DoubleLineChart(props) {
  const {data} = props 
  const option = {
    legend: {
      show: false,
        bottom: 2,
        padding:[0,0,0,10],
        left: 'start',
        itemGap: 4,
        itemWidth: 7,
        itemHeight: 7,
        textStyle: {
            color: '#d6d6d6',
            fontSize: 10
          },
          data: [ 'Days'],
    },
    tooltip: {
      show: true,
      ...props?.tooltip,
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      borderColor: 'rgba(255,255,255,0.3)',
      borderWidth: 1,
      textStyle: {
          color: '#fff',
          fontWeight: 500,
          fontSize: 13,
      },
      extraCssText: `
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          border-radius: 6px;
          padding: 8px 12px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
      `,
    },
    grid: {
      top: "20%",
      left: "8%",
      right: "8%",
      bottom: "5%",
      containLabel: true,
    },
    xAxis: {
      type: "category",
      boundaryGap: false,
      splitLine: {
        show: false,
        lineStyle: { color: "rgba(255,255,255,0.14)" },
      },
      axisLine: { show: false },
      axisTick: { show: false },
      axisLabel: {
        color: "#D6D6D6",
        fontSize: 12,
        overflow: "break",
        interval: 0,
      },
      // data: ["4 Feb", "6 Feb", "8 Feb", "10 Feb"],
      data: data.map(item => item?.INCIDENT_TIME),
    },
    yAxis: {
      type: "value",
      splitLine: { show: false },
      axisLabel: {
        show: false,
        color: "#D6D6D6",
        fontSize: 14,
        padding: [0, 15, 0, 0],
      },
      // min: 0,
      // max: 400,
      // interval: 100,
    },
    series: [
      {
        name: "Days",
        type: "line",
        symbolSize: 10,
        symbol: "circle",
        itemStyle: { color: "#79543A" , borderWidth: 2, },
        lineStyle: { color: "#79543A", width: 2 },
        // areaStyle: {
        //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
        //     { offset: 0, color: "rgb(161, 37, 42,0.60)" },
        //     { offset: 1, color: "rgba(229, 241, 232, 0.50)" },
        //   ]),
        // },
        // data: [150, 109, 114, 120, 60, 2],
        areaStyle: {
          color: {
            type: "linear",
            x: 0,
            y: 0,
            x2: 0,
            y2: 1,
            colorStops: [
              { offset: 0, color: "rgba(245,198,158,0.20)" },
              { offset: 1, color: "rgba(60,46,15,0)" },
            ],
          },
        },
        data: data.map(item => {
          return {
            ...item,
            value: item?.METRIC_NUMERATOR
          }
        }),
        label: {
          show: true,
          position: "top",
          color: "#fff",
          fontSize: 10,
          distance: 3,
        },
      },
    ],
  };


  return (
     <ReactEcharts
                option={option}
                opts={{renderer:'svg'}}
                style={{ width: '100%', height: '100%' }}
            />
  )
}
